import { postTagLink } from '@api';
import { refreshCurrentInitiativeTagsSaga } from '../../initiatives/tags/get';
import { updateSonarObjectReferences } from '../../sonar-objects/_idMap/actions';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTagsLinkPostAsyncSlice = createPostAsyncSlice({
	additionalReceiveSteps: [
		{
			actionHandler: refreshCurrentInitiativeTagsSaga,
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateSonarObjectReferences(
					request.sonarObjectIds.map((sonarObjectId) => ({
						sonarObjectId,
						tags: {
							toAdd: request.sonarObjectTagId
						}
					}))
				)
		]
	},
	name: 'CoreTagsLink',
	receive: false,
	request: true,
	requestHandler: postTagLink,
	yieldType: SagaYieldType.Every
});
